import React from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import "./style.css";
import Intro from "./views/intro";
import Editorial from "./views/editorial";
import MicroResidency from "./views/micro-residency";
import Archive from "./views/archive";
import Contact from "./views/contact";
import PrivacyPolicy from "./views/privacy-policy";
import About from "./views/about";
import Home from "./views/home";
import NotFound from "./views/not-found";
import Projects from "./components/projects";
import Overview from "./components/overview";
import LeahInterview from "./components/leahinterview";


// Hi bb // future coder // ada 10 months from now who forgot how it works again
// Don't panic. it's not too hard to understand. 
//
// This file does not define anything about how the website looks.
// the <Route> stuff defines a tree that is the map of the website, what pages exist and which are children
// and parents of which. It defines what URLs exist and how those relate to the React components. 
//
// It also provides the starting command ReactDOM.render() that kicks the whole process off.  

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="intro" element={<Intro />} />
        <Route path="editorial" element={<Editorial />} />
        <Route path="micro-residency" element={<MicroResidency />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
			  <Route path="hackingdesire" element={<LeahInterview />}> 
					  <Route path=":hyperlink"/>

			  </Route>

			  <Route path="archive" element={<Projects />}>
					  <Route path=":projectTitle" element={<Overview />} />
					  <Route path="mobile" element={<Overview-mobile />} />
			  </Route>
      </Routes>
    </Router>
  );
};

ReactDOM.render(<App />, document.getElementById("app"));
//export default App
